$shm_ba_converter $mol_list
	data null
	limit_text? \1000
	rows /
		<= Limit_row $mol_view
			sub /
				<= Limit_label $mol_text
					text \Сообщений
				<= Limit $mol_string
					hint \Количество строк
					value? <=> limit_text? \1000
					type? \number
					keyboard \numeric
		<= Format_row $mol_view
			sub /
				<= Csv $mol_button_download
					title \CSV
					file_name <= csv_file_name \ba.csv
					blob <= csv_blob null
				<= Parquet $mol_button_download
					title \Parquet
					file_name <= parquet_file_name \ba.parquet
					blob <= parquet_blob null
				<= Duckdb $mol_button_download
					title \DuckDB
					file_name <= duckdb_file_name \ba.duckdb
					blob <= duckdb_blob null
